import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { urlFor } from "@/sanity/lib/image";

export function MaskedText({ words }) {
	return (
		<div className={styles.wrapper}>
			<h2 className={styles.title}>
				{words.map((word, i) => {
					const isImage = word.backgroundType === "image";
					const imageIndex = words.slice(0, i).filter(w => w.backgroundType === "image").length;
					return (
						<MaskedWord
							word={word}
							imageIndex={imageIndex}
							key={word._key}
						/>
					);
				})}
			</h2>
		</div>
	);
}

function MaskedWord({ word }) {
	const ref = useRef();
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		const observer = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) {
				setIsVisible(true);
				observer.disconnect();
			}
		}, { rootMargin: "200px" });

		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	const isImage = word.backgroundType === "image";
	const maskImageUrl = isImage && isVisible
		? urlFor(word.maskImage).width(800).auto("format").quality(80).url()
		: null;

	const baseStyle = isImage && isVisible
		? {
			backgroundImage: `url(${maskImageUrl})`,
			backgroundSize: word.backgroundSettings?.backgroundSize || "cover",
			backgroundPosition: word.backgroundSettings?.backgroundPosition || "center",
			backgroundRepeat: "no-repeat",
			WebkitMaskImage: `url(${maskImageUrl})`,
			WebkitMaskSize: word.backgroundSettings?.backgroundSize || "cover",
			WebkitMaskPosition: word.backgroundSettings?.backgroundPosition || "center",
			WebkitMaskRepeat: "no-repeat",
			maskImage: `url(${maskImageUrl})`,
			maskSize: word.backgroundSettings?.backgroundSize || "cover",
			maskPosition: word.backgroundSettings?.backgroundPosition || "center",
			maskRepeat: "no-repeat",
		}
		: word.backgroundType === "color"
			? { color: word.backgroundColor?.hex || "#000" }
			: {};

	return (
		<span
			ref={ref}
			className={`${styles.word} ${isImage ? styles.hasImage : styles.hasColor} ${isVisible ? styles.visible : ''}`}
			style={{...baseStyle }}
		>
			{word.text}
		</span>
	);
}


